module.exports = "<p *ngIf=\"ruleText\" [innerText]=\"ruleText\"></p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/rate-rule/rate-rule.component.html
// module id = ./src/main/webapp/stay-mgmt/app/components/rate-rule/rate-rule.component.html
// module chunks = 0